/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.DrawerManager {
    import DrawerStateEnum = Meevo.Model.DrawerStateEnum;
    "use strict";

    export interface SectionHistory {
        section: DrawerManagerSectionBase;
        scrollTop: number;
        state: any;
    }

    export class DrawerManagerContextBase {
        public selectedPrinter: any;
        public selectedDrawer: Meevo.Model.Drawer;
        public selectedCreditCardTerminal: any;
        public receiptPrinters: any;
        public merchantAccount: any;
        public creditCardTerminals: any;
        public drawerPreferences: Meevo.Model.DrawerPreferences;
        public isDrawerPopped: boolean = false;
        public showPayInPayOut: boolean = false;
        protected registerSettings: any;
        protected isHostedPageAllowed: boolean = true;
        public isOpeningClosingDrawer: boolean = false;
        public tippyKiosk: Model.TippyKiosk;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected $rootScope: angular.IRootScopeService,
            protected $cookies: angular.cookies.ICookiesService,
            protected $translate: angular.translate.ITranslateService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected updatePrinterOnDrawerSelection: boolean = true
        ) {
            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_HOSTEDPAGE).then(result => {
                this.isHostedPageAllowed = result !== Model.SecurityAccessEnum.Hide;
            });
        }

        getReceiptPrinterList(): ng.IPromise<any> {
            return this.printService.getPrinterList().then((printerList) => {
                this.receiptPrinters = printerList;
            });
        }

        getMerchantAccount(merchantAccountId: Guid): ng.IPromise<any> {
            return this.dataService.customMethodData(`api/MerchantAccount/${merchantAccountId}`, "GET", null).then((response) => {
                this.merchantAccount = response.data;
            });
        }

        merchantAccountHasEodSupport(): boolean {
            return (this.merchantAccount && this.merchantAccount.hasEndOfDayReportSupport);
        }

        getCreditCardTerminalList(merchantAccountId: Guid): ng.IPromise<any> {
            const request = {
                criteria: {
                    isHostedMode: this.isHostedPageAllowed,
                }
            };

            return this.dataService.customMethodData(`api/MerchantAccount/${merchantAccountId}/Devices/List`, "POST", request).then((response) => {
                this.creditCardTerminals = _.map(response.data, (terminal: any) => {
                    if (terminal.merchantTerminalType === Meevo.Model.MerchantTerminalTypeEnum.Hosted) {
                        terminal.displayName = this.$translate.instant('LABEL_HOSTED_PAGE');
                    }
                    return terminal;
                });
            });
        }

        getDrawerPreferences() {
            return this.dataService.getItem(this.appSettings.API_ENDPOINTS.session + "/DrawerPreferences").then((data) => {
                this.drawerPreferences = data;
            });
        }

        getDrawerInfo(drawerId): ng.IPromise<Model.Drawer> {
            return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.drawer}/${drawerId}`, "GET", null).then((response) => {
                return response.data;
            });
        }

        private getDrawerFromPosStation(posStationId: string) {
            const url = `api/posHardware/device/${posStationId}?DeviceType=${Meevo.Model.DeviceTypeEnum.PosStation}`;
            return this.dataService.customMethodData(url, "GET", null).then(
                (posdata) => posdata,
                (error) => {
                    // Couldn't verify the POS Station (network error, 500, missing security key, etc) - treat it
                    // like a deleted station below, but log it since this case isn't otherwise visible.
                    this.loggingService.error(`Failed to look up POS Station ${posStationId}.`, error);
                    return null;
                }
            ).then((posdata) => {
                if (!posdata || !posdata.data || posdata.data.objectState !== Meevo.Model.ObjectStateEnum.Active) {
                    // POS Station has been deleted (or couldn't be verified) since it was activated - fall back to the drawer's own defaults
                    return this.applyDrawerDefaultPrinterAndTerminal();
                }

                if (this.updatePrinterOnDrawerSelection) {
                    if (posdata.data.useNetworkPrinter) {
                        this.selectedPrinter = _.findWhere(this.receiptPrinters, { brandId: 3 }) || {};
                    } else if (posdata.data.devicePrinterId != null) {
                        this.selectedPrinter = _.findWhere(this.receiptPrinters, { id: posdata.data.devicePrinterId });
                    } else if (this.selectedDrawer.printer.id) {
                        this.selectedPrinter = _.findWhere(this.receiptPrinters, { id: this.selectedDrawer.printer.id }); //this.selectedDrawer.printer;
                    } else if (this.drawerPreferences.lastUsedPrinterId) {
                        this.selectedPrinter = _.findWhere(this.receiptPrinters, { id: this.drawerPreferences.lastUsedPrinterId });
                    } else if (this.receiptPrinters.length > 0) {
                        this.selectedPrinter = _.findWhere(this.receiptPrinters, { brandId: 3 }) || this.receiptPrinters[0];
                    }
                    return this.printService.setSelectedPrinter(this.selectedPrinter).then(() => {
                        return this.assignDeviceTerminal(posdata.data, this.selectedDrawer);
                    });
                }
                else {
                    return this.printService.getSelectedPrinter().then((selectedPrinter) => {
                        this.selectedPrinter = selectedPrinter;
                        return this.assignDeviceTerminal(posdata.data, this.selectedDrawer);
                    });
                }
            });
        }

        private applyDrawerDefaultPrinterAndTerminal() {
            if (this.updatePrinterOnDrawerSelection) {
                // set selectedPrinter object
                if (this.selectedDrawer.printer.id) {
                    this.selectedPrinter = _.findWhere(this.receiptPrinters, { id: this.selectedDrawer.printer.id }); //this.selectedDrawer.printer;
                } else if (this.drawerPreferences.lastUsedPrinterId) {
                    this.selectedPrinter = _.findWhere(this.receiptPrinters, { id: this.drawerPreferences.lastUsedPrinterId });
                } else if (this.receiptPrinters.length > 0) {
                    this.selectedPrinter = this.receiptPrinters[0];
                }
                return this.printService.setSelectedPrinter(this.selectedPrinter).then(() => {
                    return this.assignDeviceTerminal(null, this.selectedDrawer);
                });
            }
            else {
                return this.printService.getSelectedPrinter().then((selectedPrinter) => {
                    this.selectedPrinter = selectedPrinter;
                    return this.assignDeviceTerminal(null, this.selectedDrawer);
                });
            }
        }

        getDrawer(drawerId, skipPosStation: boolean = false): ng.IPromise<any> {
            return this.getDrawerInfo(drawerId).then((data) => {
                this.selectedDrawer = data;
                this.selectedDrawer.drawerSession = {};

                let posStationId = skipPosStation ? undefined : this.$cookies.get("POSStation");
                if (posStationId != null) {
                    return this.getDrawerFromPosStation(posStationId);
                } else {
                    return this.applyDrawerDefaultPrinterAndTerminal();
                }
            });
        }

        assignDeviceTerminal(posData, drawerData) {
            if (!this.registerSettings.enableCreditCardProcessing) {
                return;
            }

            this.creditCardTerminals = [];
            this.selectedCreditCardTerminal = null;
            if (drawerData.merchantAccountId) {
                let merchantAccountId = drawerData.merchantAccountId;
                return this.getMerchantAccount(merchantAccountId).then(() => {
                    // set selectedCreditCardTerminal object
                    return this.getCreditCardTerminalList(merchantAccountId).then(() => {
                        if (posData && posData.terminalId) {
                            this.selectedCreditCardTerminal = _.findWhere(this.creditCardTerminals, { id: posData.terminalId });
                        }
                        if (!this.selectedCreditCardTerminal && drawerData && drawerData.creditCardTerminalId) {
                            this.selectedCreditCardTerminal = _.findWhere(this.creditCardTerminals, { id: drawerData.creditCardTerminalId });
                        }
                        if (!this.selectedCreditCardTerminal && this.merchantAccount.isHostedPageEnabled) {
                            this.selectedCreditCardTerminal = _.findWhere(this.creditCardTerminals, { id: null });
                        }
                        if (!this.selectedCreditCardTerminal && this.drawerPreferences && this.drawerPreferences.lastUsedCreditCardTerminalId) {
                            this.selectedCreditCardTerminal = _.findWhere(this.creditCardTerminals, { id: this.drawerPreferences.lastUsedCreditCardTerminalId });
                        }
                        if (!this.selectedCreditCardTerminal && this.creditCardTerminals.length > 0) {
                            this.selectedCreditCardTerminal = this.creditCardTerminals[0];
                        }
                    });
                });
            }
        }

        assignDeviceTerminalFromMerchantAccount(posData, drawerData, dataIsFetched: boolean = false) {
            return this.dataService.customMethodData("api/MerchantAccount/List", "GET", {}).then((response) => {
                let merchantAccounts = response.data;
                if (posData && posData.terminalId) {
                    this.selectedCreditCardTerminal = _.findWhere(this.creditCardTerminals, { id: posData.terminalId });
                    if (!this.selectedCreditCardTerminal) {
                        this.assignDeviceTerminalFromTerminal(merchantAccounts, posData.terminalId);
                    }
                }
                if (!this.selectedCreditCardTerminal && drawerData && drawerData.creditCardTerminalId) {
                    this.selectedCreditCardTerminal = _.findWhere(this.creditCardTerminals, { id: drawerData.creditCardTerminalId });
                    if (!this.selectedCreditCardTerminal) {
                        this.assignDeviceTerminalFromTerminal(merchantAccounts, drawerData.creditCardTerminalId);
                    }
                }
                if (!this.selectedCreditCardTerminal && this.creditCardTerminals.length > 0) {
                    this.selectedCreditCardTerminal = this.creditCardTerminals[0];
                }
            });
        }

        assignDeviceTerminalFromTerminal(merchantAccounts, creditCardTerminalId) {
            for (let i = 0, n = merchantAccounts.length; i < n; i++) {
                this.selectedCreditCardTerminal = _.findWhere(merchantAccounts[i].terminals, { id: creditCardTerminalId });
                if (this.selectedCreditCardTerminal) {
                    break;
                }
            }
        }
    }

    export class DrawerManagerContext extends DrawerManagerContextBase {

        public baseEndPoint: string;
        public allDrawers: any[];
        public sectionTemplatePath: string = "app/plugins/drawerManager/";
        public sections: DrawerManagerSectionBase[] = [];
        public selectedSection: DrawerManagerSectionBase;
        public openedSections: SectionHistory[];

        public posStationData: any;

        // Set by getAllDrawer() - the POSStation cookie's id, or null if absent or the station is no longer Active
        public activePosStationId: string = null;

        public actualCash: number;
        public openingNotes: string;
        public creditCardTransactionsSelectionHistory: CreditCardTransactionSelection[];
        public mostRecentHistoryForOpen: Meevo.Model.DrawerSessionStateHistory;

        public paymentTypes: Model.PaymentTypeListItem[];

        public denominations: Meevo.Model.Denomination[] = null;
        public cashDenominations: Meevo.Model.DenominationAmount[][] = null;
        public currentFieldNameForCashDenomination: string = null;
        public editingOpeningCash: boolean = false;

        public receiptPrinters: any;
        public payInOutListCash: Model.DrawerSessionPayInOut[];
        public payInOutListCheck: Model.DrawerSessionPayInOut[];

        constructor(
            protected drawerManagerController: Meevo.Plugins.DrawerManager.DrawerManagerController,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            protected $translate: angular.translate.ITranslateService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $timeout: angular.ITimeoutService,
            protected $q: angular.IQService,
            protected $filter: angular.IFilterService,
            public isDrawerHistory: boolean,
            protected $cookies: angular.cookies.ICookiesService,
            public insideRegister: boolean,
            protected tippyService: Meevo.Plugins.Tippy.TippyService
        ) {
            super(appSettings, dataService, printService, $rootScope, $cookies, $translate, securityService, loggingService, insideRegister);

            this.openedSections = [];
            this.baseEndPoint = this.appSettings.API_ENDPOINTS.drawerManager;
            this.drawerPreferences = {};
            this.initializeDrawerManagerSections(false);

            $scope.$on(Components.Common.Messages.PRINTER_SELECTED, (event, args, params) => {
                this.selectedPrinter = null;
                this.selectedPrinter = params;
            });

            $scope.$on(Components.Common.Messages.DRAWER_TERMINAL_UPDATE, (event, args, params) => {
                this.selectedCreditCardTerminal = _.findWhere(this.creditCardTerminals, { id: params });
            });
        }

        initialize(): ng.IPromise<any[]> {
            var promises: ng.IPromise<any>[] = [];
            promises.push(this.getRegisterSettings());
            promises.push(this.getAllDrawer());
            promises.push(this.getAllPaymentTypes());
            promises.push(this.getReceiptPrinterList());
            promises.push(this.getDrawerPreferences());
            return this.$q.all(promises);
        }

        getRegisterSettings() {
            return this.dataService.customMethodData("api/Tenant/BusinessInfo/Settings", "get", {}).then((data) => {
                this.registerSettings = data.data.registerSettings;
                this.initializeDrawerManagerSections(true);
            })
        }

        initializeDrawerManagerSections(registerSettingsDependency: boolean): void {
            //Note: XXXXXSection -- namespace of xxxxx.section.ts
            //Note: template -- folder name and less class for calc height. see directives/registerContext.ts for ng-includes example
            //Note: handlesOwnCrud = true

            if (registerSettingsDependency) {
                this.sections.push(new ClosingDrawerSection(this, this.dataService, this.securityService, this.modalService, this.printService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, true, this.registerSettings));
            } else {
                this.sections.push(new UnassignedDrawerSection(this, this.dataService, this.modalService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, true));
                this.sections.push(new OpeningDrawerSection(this, this.dataService, this.modalService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, true));
                this.sections.push(new DrawerOpenedSection(this, this.dataService, this.modalService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, false));
                this.sections.push(new DrawerClosedSection(this, this.dataService, this.modalService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, false));
                this.sections.push(new PayInSection(this, this.dataService, this.modalService, this.printService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, true));
                this.sections.push(new PayOutSection(this, this.dataService, this.modalService, this.printService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, true));
                this.sections.push(new CashCalculatorSection(this, this.dataService, this.modalService, this.printService, this.appSettings, this.$rootScope, this.$scope, this.$translate, this.$timeout, this.$filter, false, true, this.identityService));
                this.sections.push(new CashTransactionsSection(this, this.dataService, this.modalService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, true));
                this.sections.push(new CreditCardListingsSection(this, this.dataService, this.modalService, this.appSettings, this.$rootScope, this.$scope, this.$translate, false, true));
                this.sections.push(new DrawerHistorySection(this, this.dataService, this.modalService, this.printService, this.appSettings, this.$rootScope, this.$scope, this.$translate, this.$filter, true, true, this.$q, this.securityService));
                this.sections.push(new TipsCollectionSection(this, this.dataService, this.modalService, this.appSettings, this.$rootScope, this.$scope, this.$translate, this.$filter));
            }
        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // NOTE: Please use these three functions accordingly.
        //    selectSection - creates a new base layer and "forgets" all section history
        //    openSection   - opens the section on "top" of current section, has ability to go back to previous
        //    closeSection  - closes the current section and switches to the previous section in "layer stack"
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // Use this to switch sections from one state to another
        selectSection(sectionType: DrawerManagerSectionTypeEnum) {
            this.openedSections = []; // clear out section history
            let newSection = _.findWhere(this.sections, { sectionType: sectionType });
            if (newSection !== this.selectedSection) {
                this.selectedSection = newSection;
            }
            this.selectedSection.reset();
        }

        replaceOpenSection(newSectionType: DrawerManagerSectionTypeEnum, oldSectionType: DrawerManagerSectionTypeEnum) {
            var lastSection;
            do {
                lastSection = this.openedSections.pop();
            }
            while (lastSection != null && lastSection.section.sectionType != oldSectionType);
            this.selectedSection = _.findWhere(this.sections, { sectionType: newSectionType });
            this.selectedSection.reset();
        }

        // Use this to add new "layer" sections that can be 'closed' which will bring back to previous sections
        openSection(sectionType: DrawerManagerSectionTypeEnum, preventDataFetch: boolean = false) {
            this.openedSections.push({ section: this.selectedSection, scrollTop: $("#drawerManager-body").scrollTop(), state: this.selectedSection.getState() });
            let newSection = _.findWhere(this.sections, { sectionType: sectionType });
            if (newSection !== this.selectedSection) {
                this.selectedSection = newSection;
                this.$timeout(() => { $("#drawerManager-body").scrollTop(0); }, 10);
                this.selectedSection.reset(preventDataFetch);
            }
        }

        // Use this to switch to previous section in the section history
        closeSection() {
            var lastSection = this.openedSections.pop();
            if (lastSection) {
                this.selectedSection = lastSection.section;
                this.$timeout(() => { $("#drawerManager-body").scrollTop(lastSection.scrollTop); }, 10);
                this.selectedSection.reset();
                this.selectedSection.setState(lastSection.state);
            }
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        getActivePosStations(): ng.IPromise<Meevo.Model.Device[]> {
            return this.dataService.customMethodData("api/PosHardware/PosStation/List", "GET", null).then((response) => {
                let posHardware: Meevo.Model.PosHardware = response.data;
                let devices = (posHardware && posHardware.devices) || [];
                return devices.filter(device => device.objectState === Meevo.Model.ObjectStateEnum.Active);
            });
        }

        getAllDrawer(asLocationId?: number): ng.IPromise<any[]> {
            let posStationId = this.$cookies.get("POSStation");

            const fetchDrawers = (validPosStationId: string) => {
                this.activePosStationId = validPosStationId;

                let request = {
                    criteria: { useUserId: true }
                    , posStationId: null
                    , asLocationId: (asLocationId != null ? asLocationId : null)
                    , forRegister: this.insideRegister
                };
                if (validPosStationId && this.insideRegister) {
                    request.posStationId = validPosStationId;
                }

                return this.dataService.customMethodData("api/drawer/list/", "POST", request).then((response) => {
                    this.allDrawers = response.data;

                    this.allDrawers.forEach((dr) => {
                        const suffix = dr.drawerState === Meevo.Model.DrawerStateEnum.Close
                            ? " - " + this.$translate.instant("LABEL_CLOSED")
                            : " - " + this.$translate.instant("LABEL_OPEN");

                        dr.displayNameForDropdown = dr.displayName + suffix;
                    });

                    return this.allDrawers;
                });
            };

            if (posStationId && this.insideRegister) {
                const url = `api/posHardware/device/${posStationId}?DeviceType=${Meevo.Model.DeviceTypeEnum.PosStation}`;
                return this.dataService.customMethodData(url, "GET", null).then(
                    (posdata) => {
                        const isActive = posdata.data && posdata.data.objectState === Meevo.Model.ObjectStateEnum.Active;
                        // POS Station has been deleted since it was activated - treat it the same as no cookie set
                        return isActive ? posStationId : null;
                    },
                    () => {
                        // Couldn't verify the POS Station (network error, 500, missing security key, etc) - that is not
                        // the same as deleted, so fail open to the cookie id rather than forcing the activation prompt
                        return posStationId;
                    }
                ).then((validPosStationId) => fetchDrawers(validPosStationId));
            }

            return fetchDrawers(null);
        }
        getAllPaymentTypes() {
            let request = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    includeNonMonetary: undefined,
                    includeInactive: true
                }
            };
            return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.paymentType, request).then((response: Model.PaymentTypeListItem[]) => {
                this.paymentTypes = response;
            });
        }
        getGenericDrawerSession(drawerId, includeClosingDetails?: boolean, drawerSessionId?: string, includeDetails: boolean = true) {
            var uri = `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.drawer}/${drawerId}/session`;
            if (drawerSessionId) {
                uri += `/${drawerSessionId}`;
            }
            else {
                uri += '/Latest';
            }
            uri += `?includeClosingDetails=${includeClosingDetails ? true: false}&includeDetails=${includeDetails ? true : false}`;

            return this.dataService.customMethodData(uri, "GET", null).then((response) => {
                return response.data;
            });
        }
        getDrawerSession(drawerId, includeClosingDetails?: boolean, drawerSessionId?: string, includeDetails: boolean = true) {
            return this.getGenericDrawerSession(drawerId, includeClosingDetails, drawerSessionId, includeDetails).then((data) => {
                this.selectedDrawer.drawerSession = data;
                this.selectedDrawer.drawerState = this.selectedDrawer.drawerSession.drawerState;
                if (this.selectedDrawer &&
                    this.selectedDrawer.drawerSession &&
                    this.selectedDrawer.drawerSession.payInOutList) {
                    this.payInOutListCash = _(this.selectedDrawer.drawerSession.payInOutList).where({ paymentCategory: Model.PaymentCategoryEnum.Cash });
                    this.payInOutListCheck = _(this.selectedDrawer.drawerSession.payInOutList).where({ paymentCategory: Model.PaymentCategoryEnum.Check });
                    this.adjustCheckPayInOutWithCheckTransactions();
                }

                this.getTippyKiosk(drawerId);
            });
        }
        adjustCheckPayInOutWithCheckTransactions() {
            if (this.payInOutListCheck.length > 0) {
                let checkTrans = _.findWhere(this.selectedDrawer.drawerSession.aggregatedPaymentTransactions, { paymentCategory: Meevo.Model.PaymentCategoryEnum.Check });
                var totalCheckPayInAmount: number = 0;
                _.chain(this.payInOutListCheck).where({ payInOutType: Model.PayInOutEnum.PayIn })
                    .each((item) => {
                        totalCheckPayInAmount = this.addNormalizedNumbers(totalCheckPayInAmount, item.cashAmount);
                    });
                if (checkTrans) {
                    checkTrans.amount = this.addNormalizedNumbers(checkTrans.amount, totalCheckPayInAmount);
                }
                else {
                    let paymentTypeCheck = _(this.paymentTypes).findWhere({ paymentCategory: Meevo.Model.PaymentCategoryEnum.Check });
                    if (paymentTypeCheck) {
                        let checkPayInOut: any = {
                            amount: totalCheckPayInAmount,
                            count: 1,
                            displayName: this.$translate.instant("LABEL_CHECK"),
                            paymentCategory: Meevo.Model.PaymentCategoryEnum.Check,
                            paymentTypeDisplayName: this.$translate.instant("LABEL_CHECK"),
                            paymentTypeId: paymentTypeCheck.id
                        };
                        this.selectedDrawer.drawerSession.aggregatedPaymentTransactions.push(checkPayInOut);
                    }
                }
            }
        }
        saveAsDefaultPrinter() {
            this.setDrawerPreferences(null, this.selectedPrinter ? this.selectedPrinter.id : null, null).then(() => {
                this.printService.setSelectedPrinter(this.selectedPrinter);
            });
        }
        saveAsDefaultCreditCardTerminal() {
            let terminal = this.selectedCreditCardTerminal || {};
            this.$rootScope.$broadcast(Components.Common.Messages.TERMINAL_SELECTED, { name: "register" }, { terminalId: terminal.id });

            // drawer preferences are not updated in history mode
            if (!this.isPastTransactionMode()) {
                this.setDrawerPreferences(null, null, terminal.id);
            }
        }
        checkDrawerState() {
            if (this.selectedDrawer.drawerState === Meevo.Model.DrawerStateEnum.Close) {
                this.selectSection(DrawerManagerSectionTypeEnum.DrawerClosed);
            } else if (this.selectedDrawer.drawerState === Meevo.Model.DrawerStateEnum.Open) {
                this.selectSection(DrawerManagerSectionTypeEnum.DrawerOpened);
            }
        }
        getDrawerList() {
            return this.allDrawers;
        }

        isLastUsedDrawerAvailable(): boolean {
            let isAvailable: boolean = false;
            let lastUsedDrawerId = this.drawerPreferences.lastUsedDrawerId;
            if (lastUsedDrawerId) {
                if (this.allDrawers) {
                    for (var i = 0; i < this.allDrawers.length; i++) {
                        if (this.allDrawers[i].id == lastUsedDrawerId) {
                            isAvailable = true;
                            break;
                        }
                    }
                }
            }
            return isAvailable;
        }

        getAssignedDrawerModel() {
            return this.selectedDrawer;
        }

        setHistoryDrawer(drawer: Meevo.Model.Drawer, drawerSessionId: string) {
            if (!drawer || !drawerSessionId) {
                return;
            }

            this.getDrawer(drawer.id, true).then(() => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.REGISTER_DRAWER_SELECTED, { name: "register" }, {
                    selectedDrawer: this.selectedDrawer,
                    selectedCreditCardTerminal: this.selectedCreditCardTerminal,
                    selectedPrinter: this.selectedPrinter,
                    reason: Meevo.Model.DrawerSelectionReasonEnum.TransactionInsert
                });

                this.getDrawerSession(drawer.id, false, drawerSessionId, false);
            });
        }

        setCurrentDrawer(drawer: Meevo.Model.Drawer) {
            if (!drawer) {
                return;
            }

            this.getDrawer(drawer.id).then(() => {
                this.getDrawerSession(drawer.id, false, undefined, false);
                this.getTippyKiosk(drawer.id);
            });
        }

        setSelectedDrawer(drawer: Meevo.Model.Drawer, includeDrawerSessionDetails: boolean, reason: Meevo.Model.DrawerSelectionReasonEnum) {
            if (!drawer) {
                return;
            }

            this.getDrawer(drawer.id).then(() => {
                this.setDrawerPreferences(this.selectedDrawer.id, this.selectedPrinter ? this.selectedPrinter.id : null, this.selectedCreditCardTerminal ? this.selectedCreditCardTerminal.id : null);

                if (this.insideRegister) {
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.REGISTER_DRAWER_SELECTED, { name: "register" }, {
                        selectedDrawer: this.selectedDrawer,
                        selectedCreditCardTerminal: this.selectedCreditCardTerminal,
                        selectedPrinter: this.selectedPrinter,
                        reason: reason
                    });
                }

                this.getDrawerSession(drawer.id, false, undefined, !this.insideRegister || includeDrawerSessionDetails).then(() => {
                    this.checkDrawerState();
                });

                this.getTippyKiosk(drawer.id);
            });
        }

        setDrawerPreferences(drawerId?: string, printerId?: string, creditCardTerminalId?: string): ng.IPromise<any> {
            if (!new Guid(drawerId).equals(this.drawerPreferences.lastUsedDrawerId)) {
                let isPrinterSystemGuid = (!printerId) ? false : (new Guid(printerId.toString())).equals(Guid.empty);
                let usedPrinterId = isPrinterSystemGuid ? null : printerId;
                let request = {
                    lastUsedDrawerId: drawerId
                    , lastUsedPrinterId: usedPrinterId
                    , lastUsedCreditCardTerminalId: creditCardTerminalId
                    , clearLastUsedPrinter: isPrinterSystemGuid
                };
                return this.dataService.patch(this.appSettings.API_ENDPOINTS.session + "/DrawerPreferences", request).then((data) => {
                    this.drawerPreferences = data;
                });
            }
            else {
                return this.$q.resolve();
            }
        }

        patchDrawerSession(drawerSession: Model.DrawerSession) {
            let request = { "DrawerSession": drawerSession };
            return this.dataService.patch("drawer/" + drawerSession.drawerId + "/session/" + drawerSession.id, drawerSession)
                .then((response) => {
                    return this.getDrawerSession(this.selectedDrawer.id, true, drawerSession.id);
                });
        }

        createDrawerSession() {
            let defer = this.$q.defer();
            let newDrawerSession = _.clone(this.selectedDrawer.drawerSession);
            newDrawerSession.drawerState = Meevo.Model.DrawerStateEnum.Open;
            this.dataService.add("drawer", newDrawerSession, new Guid(this.selectedDrawer.id), "session")
                .then((response) => {
                    this.selectedDrawer.drawerSession = response;
                    this.selectedDrawer.drawerState = this.selectedDrawer.drawerSession.drawerState;
                    this.selectedDrawer.drawerSession.note = this.getLastDrawerSessionNote(Model.DrawerStateEnum.Open);
                    this.payInOutListCash = [];
                    this.payInOutListCheck = [];
                    this.getAllDrawer();
                    defer.resolve();
                }).catch(response => {
                    defer.reject();
                    this.checkRefreshDrawer(response);
                });
            return defer.promise;
        }

        closeDrawerSession() {
            let defer = this.$q.defer();
            let newDrawerSession = _.clone(this.selectedDrawer.drawerSession);
            newDrawerSession.drawerState = Meevo.Model.DrawerStateEnum.Close;
            this.dataService.update("drawer/" + new Guid(this.selectedDrawer.id) + "/session/" + new Guid(this.selectedDrawer.drawerSession.id), newDrawerSession)
                .then((response) => {
                    this.selectedDrawer.drawerSession = response;
                    // If drawer is still open, we had stale data on the page.
                    if (response.drawerState === Meevo.Model.DrawerStateEnum.Open) {
                        defer.reject({ errorCode: "STALE_DATA" });
                    }
                    else {
                        this.selectedDrawer.drawerState = this.selectedDrawer.drawerSession.drawerState;
                        this.selectedDrawer.drawerSession.note = this.getLastDrawerSessionNote(Model.DrawerStateEnum.Close);
                        this.getAllDrawer();
                        defer.resolve();
                    }
                }).catch(response => {
                    defer.reject();
                    this.checkRefreshDrawer(response);
                });
            return defer.promise;
        }

        reopenDrawerSession() {
            let defer = this.$q.defer();
            let newDrawerSession = _.clone(this.selectedDrawer.drawerSession);
            newDrawerSession.drawerState = Meevo.Model.DrawerStateEnum.Open;
            this.dataService.update("drawer/" + new Guid(this.selectedDrawer.id) + "/session/" + new Guid(this.selectedDrawer.drawerSession.id), newDrawerSession)
                .then((response) => {
                    this.selectedDrawer.drawerSession = response;
                    this.selectedDrawer.drawerState = this.selectedDrawer.drawerSession.drawerState;
                    this.selectedDrawer.drawerSession.note = this.getLastDrawerSessionNote(Model.DrawerStateEnum.Open);
                    this.getAllDrawer();
                    defer.resolve();
                }).catch(response => {
                    defer.reject();
                    this.checkRefreshDrawer(response);
                });
            return defer.promise;
        }

        private checkRefreshDrawer(response) {
            if (response.data && response.data.responseStatus && response.data.responseStatus.message == "REFRESHDRAWER") {
                this.getDrawerSession(this.selectedDrawer.id).then(() => {
                    this.checkDrawerState();
                });
            }
        }

        getDrawerSessionHistory() {
            return this.selectedDrawer &&
                   this.selectedDrawer.drawerSession &&
                   this.selectedDrawer.drawerSession.drawerSessionHistory;
        }

        getDrawerSessionPayInOut(paymentCategory: Model.PaymentCategoryEnum) {
            let returnPayInOutList = [];
            switch (paymentCategory) {
                case Model.PaymentCategoryEnum.Cash:
                    returnPayInOutList = this.payInOutListCash;
                    break;
                case Model.PaymentCategoryEnum.Check:
                    returnPayInOutList = this.payInOutListCheck;
                    break;
            };

            return this.selectedDrawer &&
                this.selectedDrawer.drawerSession &&
                this.selectedDrawer.drawerSession.payInOutList &&
                returnPayInOutList;
        }

        getDrawerSessionNotes() {
            return this.selectedDrawer &&
                   this.selectedDrawer.drawerSession &&
                   this.selectedDrawer.drawerSession.notes;
        }

        getDrawerStateLabel(drawerState, index) {
            if (drawerState == Meevo.Model.DrawerStateEnum.Open) {
                if (index == 0) {
                    return this.$translate.instant("LABEL_OPENED_BY");
                } else {
                    const drawerSessionHistory = this.getDrawerSessionHistory() || [];
                    let prevDrawerSessionHistory = drawerSessionHistory[index - 1];
                    if (prevDrawerSessionHistory.drawerState == Meevo.Model.DrawerStateEnum.Close) {
                        return this.$translate.instant("LABEL_REOPENED_BY");
                    }
                    return this.$translate.instant("LABEL_EDITED_OPENING_BY");
                }
            } else {
                if (index > 0) {
                    const drawerSessionHistory = this.getDrawerSessionHistory() || [];
                    let prevDrawerSessionHistory = drawerSessionHistory[index - 1];
                    if (prevDrawerSessionHistory.drawerState == Meevo.Model.DrawerStateEnum.Close) {
                        return this.$translate.instant("LABEL_EDITED_CLOSING_BY");
                    }
                }
                return this.$translate.instant("LABEL_CLOSED_BY");
            }
        }

        getPayInOutLabel(payInOut) {
            if (payInOut == Meevo.Model.PayInOutEnum.PayIn)
                return this.$translate.instant("LABEL_PAY_IN");
            else
                return this.$translate.instant("LABEL_PAY_OUT");
        }

        editPayInOut(payInOut: Meevo.Model.PayInOut) {

            switch (payInOut.payInOutType) {
                case Meevo.Model.PayInOutEnum.PayIn:
                    this.gotoEditPayIn(payInOut);
                    break;

                case Meevo.Model.PayInOutEnum.PayOut:
                    this.gotoEditPayOut(payInOut);
                    break;
            }
        }

        deletePayInOut(payInOut: Meevo.Model.PayInOut, includeClosingDetails: boolean = false, paymentCategory: Model.PaymentCategoryEnum = Model.PaymentCategoryEnum.Cash) {
            let that = this;
            this.modalService.confirm("MESSAGE_DELETE_CONFIRMATION").then((confirmResult: boolean) => {
                if (confirmResult) {
                    that.dataService.customMethodData("api/drawer/" + new Guid(this.selectedDrawer.id) + "/PayInOut/" + new Guid(payInOut.id), "DELETE", null).then((response) => {
                        this.getDrawerSession(this.selectedDrawer.id, includeClosingDetails, (includeClosingDetails ? this.selectedDrawer.drawerSession.id : null)).then((data) => {
                            this.getDrawerSessionPayInOut(paymentCategory);
                            this.selectedSection.reset();
                        });
                    });
                }
            });
        }

        getLastDrawerSessionNote(drawerState?: Model.DrawerStateEnum) {
            let lastNote = "";
            const drawerSessionNotes = this.getDrawerSessionNotes();

            if (drawerSessionNotes && drawerSessionNotes.length > 0) {
                if (drawerState != null) {
                    for (const dsn of drawerSessionNotes) {
                        if (dsn.drawerState == drawerState) {
                            lastNote = dsn.note;
                            break;
                        }
                    }
                }
                else {
                    lastNote = drawerSessionNotes[drawerSessionNotes.length - 1].note;
                }
            }

            return lastNote;
        }

        setCreditCardActualTotal(paymentTypeId: string, total: number, transactionSelection?: CreditCardTransactionSelection) {
            let paymentTransaction = _.findWhere(this.selectedDrawer.drawerSession.aggregatedPaymentTransactions, { paymentTypeId: paymentTypeId });
            if (paymentTransaction) {
                paymentTransaction.actualAmount = total;
            }

            if (transactionSelection) {
                this.creditCardTransactionsSelectionHistory[paymentTypeId] = transactionSelection;
            }
        }

        setCalculatedCashTotal(total: number, cashDenomination: Meevo.Model.DenominationAmount[]) {
            this.cashDenominations[this.currentFieldNameForCashDenomination] = cashDenomination;
            if (this.selectedDrawer && this.selectedDrawer.drawerSession) {
                this.selectedDrawer.drawerSession[this.currentFieldNameForCashDenomination] = total;
            }
        }

        payInCash = (payInObj) => {
            if (payInObj.id) {
                return this.dataService.update("drawer/" + new Guid(this.selectedDrawer.id) + "/PayIn", payInObj);
            }
            else {
                return this.dataService.add("drawer/" + new Guid(this.selectedDrawer.id) + "/PayIn", payInObj);
            }
        }

        payOutCash = (payOutObj) => {
            if (payOutObj.id) {
                return this.dataService.update("drawer/" + new Guid(this.selectedDrawer.id) + "/PayOut", payOutObj);
            }
            else {
                return this.dataService.add("drawer/" + new Guid(this.selectedDrawer.id) + "/PayOut", payOutObj);
            }
        }

        showNegative = (payInOutType) => {
            return payInOutType == Meevo.Model.PayInOutEnum.PayOut ? "-" : "";
        }

        showDrawerSessionInfo(drawerId: string, drawerSessionId?: string) {
            this.getDrawer(drawerId).then(() => {
                this.getDrawerSession(drawerId, false, drawerSessionId).then(() => {
                    if (this.selectedDrawer.drawerState == Meevo.Model.DrawerStateEnum.Close) {
                        this.openSection(DrawerManagerSectionTypeEnum.DrawerClosed);
                    }
                    else if (this.selectedDrawer.drawerState == Meevo.Model.DrawerStateEnum.Open) {
                        this.openSection(DrawerManagerSectionTypeEnum.DrawerOpened);
                    }

                    if (this.selectedDrawer.drawerSession.drawerState === Model.DrawerStateEnum.Close) {
                        // get latest drawer session info
                        this.getGenericDrawerSession(drawerId, false).then((data) => {
                            let isLatest = (data.id === this.selectedDrawer.drawerSession.id);
                            let isClosed = (data.drawerState === Meevo.Model.DrawerStateEnum.Close);
                            this.selectedSection.initialize(isClosed, (isClosed && isLatest));
                        });
                    }
                });
            });
        }

        isPastTransactionMode(): boolean {
            return this.drawerManagerController &&
                   this.drawerManagerController.registerContext &&
                   this.drawerManagerController.registerContext.registerTicketService &&
                   this.drawerManagerController.registerContext.registerTicketService.isPastTransactionMode;
        }

        isEditOpeningCashDisabled(drawerClosed: boolean): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            if (drawerClosed) {
                const drawerSessionHistory = this.getDrawerSessionHistory() || [];
                if (drawerSessionHistory.length === 0) {
                    return true;
                }
            }

            return false;
        }

        isEditClosingDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isPayOutDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isPayInDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isCloseDrawerDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isCashTransactionsDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isDrawerHistoryDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isPopDrawerDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return false;
        }

        isSelectDrawerDisabled(): boolean {
            if (this.isPastTransactionMode()) {
                return true;
            }

            return this.isDrawerHistory;
        }

        popDrawer() {
            if (!this.selectedPrinter) {
                this.modalService.alert("There is no drawer connected to this POS");
                return;
            }
            // Visual indicator state for showing drawer is popped then return to original state via timeout
            this.isDrawerPopped = true;
            this.$timeout(() => {
                this.isDrawerPopped = false;
            }, 700)
            return this.printService.openDrawer();
        }

        gotoEditOpeningCash() {
            // need to include closing details, if Drawer is closed, because it will get updated as well on the repo
            let includeClosing = (this.selectedDrawer.drawerSession.drawerState == Meevo.Model.DrawerStateEnum.Close);
            this.getDrawerSession(this.selectedDrawer.id, includeClosing, this.selectedDrawer.drawerSession.id).then(() => {
                this.cashDenominations = [];
                this.editingOpeningCash = true;
                this.selectedDrawer.drawerSession.note = this.getLastDrawerSessionNote(Model.DrawerStateEnum.Open);
                this.selectedDrawer.drawerSession.actualCashInDrawer = this.selectedDrawer.drawerSession.openCashAmount;
                this.openSection(DrawerManagerSectionTypeEnum.OpeningDrawer);
            });
        }

        gotoEditPayIn(payIn: Meevo.Model.PayInOut) {
            this.openSection(DrawerManagerSectionTypeEnum.PayIn);
            this.selectedSection.initialize(payIn);
        }

        gotoEditPayOut(payOut: Meevo.Model.PayInOut) {
            this.openSection(DrawerManagerSectionTypeEnum.PayOut);
            this.selectedSection.initialize(payOut);
        }

        gotoPayOutRemoveCash(fromClosing = false) {
            this.openSection(DrawerManagerSectionTypeEnum.PayOut);
        }

        isCheckPayInAllowed(): boolean {
            return _(this.paymentTypes).some((paymentType) =>
                paymentType.paymentCategory === Model.PaymentCategoryEnum.Check
                && paymentType.objectState === Model.ObjectStateEnum.Active);
        }

        getPayInAddCashLabelKey(): string {
            return this.isCheckPayInAllowed() ? "LABEL_PAY_IN_ADD_CASH" : "LABEL_PAY_IN_ADD_CASH_ONLY";
        }

        gotoPayInAddCash(fromClosing = false) {
            this.openSection(DrawerManagerSectionTypeEnum.PayIn);
        }

        gotoCloseDrawer() {
            let proceedWithClosing = () => {
                this.getDrawerSession(this.selectedDrawer.id).then(() => {
                    this.cashDenominations = [];
                    this.creditCardTransactionsSelectionHistory = [];
                    // default cash amount setting
                    this.selectedDrawer.drawerSession.note = this.getLastDrawerSessionNote(Model.DrawerStateEnum.Close);
                    this.selectedDrawer.drawerSession.cashLeftInDrawer = this.selectedDrawer.cashAmount;
                    this.selectedDrawer.drawerSession.aggregatedPaymentTransactions.forEach(payment => {
                        if (_([Model.PaymentCategoryEnum.Cash,
                        Model.PaymentCategoryEnum.CreditDebit,
                        Model.PaymentCategoryEnum.Check,
                        Model.PaymentCategoryEnum.Debit]).all((excludedPaymentCategory) => {
                            return payment.paymentCategory != excludedPaymentCategory
                        })) {
                            payment.actualAmount = payment.amount;
                        }
                    });
                    this.isOpeningClosingDrawer = true;
                    this.openSection(DrawerManagerSectionTypeEnum.ClosingDrawer);
                    this.selectedSection.initialize(false);
                });
            }

            var promises: ng.IPromise<string[]>[] = [this.checkForNonCheckedOutAppointments(), this.checkForSalesOnHold()];

            this.$q.all(promises).then(responses => {
                var warnings = responses
                                .filter(response => !!response && response.length > 0)
                                .map(response => `<li>${response.join("</li><li>")}</li>`)
                                .join('');

                if (!warnings || warnings.length < 1) {
                    proceedWithClosing();
                    return;
                }

                var stillCloseDrawer = this.$translate.instant('MESSAGE_STILL_CLOSE_DRAWER');
                var message = `<ul>${warnings}</ul>${stillCloseDrawer}`;

                this.modalService
                    .alert(message,
                            Components.Modal.ModalTranslationModes.Translate,
                            false,
                            {
                                showCancelButton: true,
                                cancelButtonContentKey: 'LABEL_NO',
                                okButtonContentKey:'LABEL_YES'
                            })
                    .then(result => {
                        if (result) {
                            proceedWithClosing();
                        }
                    });
            });
        }

        checkForSalesOnHold(): ng.IPromise<string[]> {
            var request = {
                criteria: {
                    excludeIdList: null,
                    holdTypes: [Meevo.Model.HoldTypeEnum.Register,
                        Meevo.Model.HoldTypeEnum.Recovery]
                }
            }
            return this.dataService.customMethodData("/api/salehold/Count", "post", request)
                .then(response => {
                    if (response.data.onHoldCount == 0) {
                        return undefined;
                    }
                    let messages: string[] = [];
                    messages.push(this.$translate.instant('LABEL_CLOSE_DRAWER_TRANSACTIONS_ON_HOLD'));
                    if (response.data.selfPayCount == 1) {
                        messages.push(
                            this.$translate.instant('LABEL_CLOSE_DRAWER_TRANSACTION_ON_HOLD_SELF_PAY'))
                    }
                    else if (response.data.selfPayCount > 1) {
                        messages.push(this.$translate.instant('LABEL_CLOSE_DRAWER_TRANSACTIONS_ON_HOLD_SELF_PAY', { count: response.data.selfPayCount }));
                    }
                    return messages;
                });
        }

        checkForNonCheckedOutAppointments(): ng.IPromise<string[]> {
            return this.dataService.customMethodData("/api/timeclock/locationTime", "get", {}).then(timeResponse => {
                let appointmentServiceRequest = {
                    criteria: {
                        startDate: moment(timeResponse.data.locationTime).startOf("day").toDate(),
                        endDate: moment(timeResponse.data.locationTime).startOf("day").add("days",1).toDate(),
                        transitionStates: [
                            Meevo.Model.AppointStateEnum.Booked,
                            Meevo.Model.AppointStateEnum.Arrived,
                            Meevo.Model.AppointStateEnum.CheckedIn,
                            Meevo.Model.AppointStateEnum.RunningLate],
                        finalStates: [Model.AppointFinalStateEnum.None]
                    }
                }


                return this.dataService
                    .customMethodData("api/AppointmentService/Count", "post", appointmentServiceRequest)
                    .then(response => response.data > 0 ? [this.$translate.instant('MESSAGE_DRAWER_CLOSING_NOT_CHECKED_OUT_APPOINTMENTS')] : undefined);
            });
        }

        gotoEditClosing() {
            this.getDrawerSession(this.selectedDrawer.id, true, this.selectedDrawer.drawerSession.id).then(() => {
                this.cashDenominations = [];
                this.creditCardTransactionsSelectionHistory = [];
                this.selectedDrawer.drawerSession.note = this.getLastDrawerSessionNote(Model.DrawerStateEnum.Close);
                this.openSection(DrawerManagerSectionTypeEnum.ClosingDrawer);
                this.selectedSection.initialize(true);
            });
        }

        gotoOpenDrawer() {
            this.getDrawerSession(this.selectedDrawer.id).then(() => {
                this.cashDenominations = [];
                this.editingOpeningCash = false;
                this.isOpeningClosingDrawer = true;
                this.selectedDrawer.drawerSession.note = "";
                this.selectedDrawer.drawerSession.actualCashInDrawer = null;
                this.selectedDrawer.drawerSession.closeCashAmount = this.selectedDrawer.drawerSession.closeCashAmount || this.selectedDrawer.cashAmount;
                this.openSection(DrawerManagerSectionTypeEnum.OpeningDrawer);
            });
        }

        gotoCashTransactions(isClosing) {
            this.getCashTransactionPaymentType()
                .then(paymentTypeId => {
                    this.openSection(DrawerManagerSectionTypeEnum.CashTransactions);
                    this.selectedSection.initialize(paymentTypeId, isClosing);
                });
        }

        gotoTipsCollection(isClosing: boolean) {
            this.openSection(DrawerManagerSectionTypeEnum.TipsCollection);
            this.selectedSection.initialize(this.selectedDrawer.drawerSession.id);
        }

        gotoCreditCardListings(paymentType, isClosing, isReadOnly, preventDataFetch: boolean = false) {
            this.openSection(DrawerManagerSectionTypeEnum.CreditCardListings, preventDataFetch);
            if (isClosing) {
                this.selectedSection.initialize(paymentType.paymentTypeId, this.getPaymentTypeDisplayName(paymentType), true,
                    paymentType.paymentCategory, this.creditCardTransactionsSelectionHistory[paymentType.paymentTypeId], isReadOnly);
            }
            else {
                this.selectedSection.initialize(paymentType.paymentTypeId, this.getPaymentTypeDisplayName(paymentType), false, paymentType.paymentCategory);
            }
        }

        public getPaymentTypeDisplayName(paymentType) {
            const key = 'LABEL_PAYMENT_TYPE_' + paymentType.paymentCategory;
            const lookup = this.$translate.instant(key);
            if (lookup !== key) {
                return lookup;
            }

            return paymentType.paymentTypeDisplayName;
        }

        gotoCashCalculator(fieldName: string) {
            this.currentFieldNameForCashDenomination = fieldName;
            this.openSection(DrawerManagerSectionTypeEnum.CashCalculator);
        }

        gotoDrawerHistory(drawerId?: string) {
            if (this.isDrawerHistory) {
                this.closeSection();
            }
            else {
                if (this.insideRegister) {
                    this.selectSection(DrawerManagerSectionTypeEnum.DrawerHistory);
                    this.selectedSection.initialize(this.selectedDrawer.id);
                }
                else {
                    this.$rootScope.$broadcast("gotoState", { stateName: "drawerHistory", stateParams: { id: this.selectedDrawer.id } });
                }
            }
        }

        getCashTransactionPaymentType(): ng.IPromise<string> {
            if (this.paymentTypes) {
                const deferred = this.$q.defer<string>();

                deferred.resolve(getType(this.paymentTypes));

                return deferred.promise;
            } else {
                return this.getAllPaymentTypes()
                    .then(() => {
                        return getType(this.paymentTypes);
                    });
            }

            function getType(paymentTypes: Model.PaymentTypeListItem[]) {
                const paymentType = _.findWhere(paymentTypes, { paymentCategory: Meevo.Model.PaymentCategoryEnum.Cash });

                if (paymentType) {
                    return paymentType.id;
                }
            }
        }

        getCashTransactionPaymentItem() {
            if (this.selectedDrawer && this.selectedDrawer.drawerSession && this.selectedDrawer.drawerSession.aggregatedPaymentTransactions) {
                let cashTrans = _.findWhere(this.selectedDrawer.drawerSession.aggregatedPaymentTransactions, { paymentCategory: Meevo.Model.PaymentCategoryEnum.Cash });
                return cashTrans;
            }
            else {
                return null;
            }
        }

        getMoneyDenomination(): ng.IPromise<Meevo.Model.Denomination[]> {
            if (this.denominations == null) {
                return this.dataService.getListPaged("denomination", { criteria: { currency: Meevo.Model.CurrencyEnum[this.appSettings.APP_ISOCURRENCYCODE] } }).then((response: Meevo.Model.Denomination[]) => {
                    this.denominations = response;
                    return this.denominations;
                });
            }
            else {
                var d = this.$q.defer<Meevo.Model.Denomination[]>();
                if (this.currentFieldNameForCashDenomination && this.cashDenominations[this.currentFieldNameForCashDenomination]) {
                    d.resolve(this.cashDenominations[this.currentFieldNameForCashDenomination]);
                }
                else {
                    d.resolve(this.denominations);
                }
                return d.promise;
            }
        }
        /**
         * Determines whether the application is in CO mode
         */
        public isApplicationModeCO(): boolean {
            return this.identityService.inCentralOfficeMode();
        }

        resetMoneyDenomination() {
            this.cashDenominations[this.currentFieldNameForCashDenomination] = null;
            delete this.cashDenominations[this.currentFieldNameForCashDenomination];
        }

        resetCreditCardSelection(paymentTypeId) {
            this.creditCardTransactionsSelectionHistory[paymentTypeId] = null;
            delete this.creditCardTransactionsSelectionHistory[paymentTypeId];
        }

        normalizeNumber(value: number): number {
            return this.roundingService.normalizeNumber(value);
        }

        normalizeDecimalPlaces(value: number) {
            return this.roundingService.normalizeDecimalPlaces(value);
        }

        subtractNormalizedNumbers(...values: number[]): number {
            return this.roundingService.subtractNormalizedNumbersSpread(...values);
        }

        addNormalizedNumbers(...values: number[]): number {
            return this.roundingService.addNormalizedNumbersSpread(...values);
        }

        performOperationOnNormalizedNumbers(op: Function, values: number[]): number {
            return this.roundingService.performOperationOnNormalizedNumbersSpread(op, values);
        }

        printEodReportForSelectedTerminal() {
            if (this.selectedCreditCardTerminal) {
                var msg = this.$translate.instant("MESSAGE_PRINT_EOD_REPORT", { deviceName: this.selectedCreditCardTerminal.displayName });
                return this.modalService
                    .confirm(msg, Components.Modal.ModalTranslationModes.DoNotTranslate)
                    .then(() => {
                        return this.dataService.customMethodData(`api/MerchantAccount/${this.merchantAccount.id}/Device/${this.selectedCreditCardTerminal.id}/EODReport`, "POST", null);
                    });
            } else {
                return this.modalService.alert("MESSAGE_CANNOT_PRINT_EOD_REPORT");
            }
        }

        openTransactionEditorTransHist(transactionNumber: string): void {
            if (!transactionNumber || transactionNumber === "N/A") return;

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: Number(transactionNumber),
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };
            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams
            });
        }

        getPayInOutDate() {
            let closedSession = _(this.selectedDrawer.drawerSession.drawerSessionHistory).findWhere({ drawerState: Meevo.Model.DrawerStateEnum.Close });
            if (closedSession) {
                return moment(closedSession.dateUpdated).toDate();
            }
            return moment(new Date()).toDate();;
        }

        getPayInOutTotal(paymentCategory?: Model.PaymentCategoryEnum) {
            let total: number = 0;

            if (this.selectedDrawer.drawerSession.payInOutList) {
                let payInOutList = paymentCategory ?
                    _(this.selectedDrawer.drawerSession.payInOutList).where({ paymentCategory: paymentCategory }) :
                    this.selectedDrawer.drawerSession.payInOutList;
                for (const payInOutItem of payInOutList) {
                    let amount = payInOutItem.cashAmount * (payInOutItem.payInOutType === Meevo.Model.PayInOutEnum.PayOut ? -1 : 1);
                    total = this.addNormalizedNumbers(total, amount);
                }
            }
            return total;
        }

        getTippyKiosk(drawerId: string) {
            this.tippyKiosk = undefined;

            this.tippyService.getKioskByDrawerId(drawerId).then(kiosk => {
                this.tippyKiosk = kiosk;

                if (!kiosk || !kiosk.lockedByUserId) {
                    return;
                }

                this.dataService.getItem('Employee', new Guid(kiosk.lockedByUserId))
                    .then((employee: Model.Employee) => (this.tippyKiosk as any).lockedByDisplayName = employee.userName);
            });
        }

        manualUnlockTippyKiosk() {
            this.modalService.yellowConfirm('MESSAGE_TIPPY_KIOSK_UNLOCK', Components.Modal.ModalTranslationModes.Translate, false)
                .then(response => {
                    if (response) {
                        this.tippyService.unlockKiosk(this.tippyKiosk.deviceId).then(() => this.getTippyKiosk(this.selectedDrawer.id));
                    }
                });
        }
    }
}